import { h } from 'preact'
import UserAvatar from '../User/UserAvatar'
import Phrase from '../../libs/translationsUtils/phrase'
import Tooltip from '../ui-components/Tooltip'

export type LikedUserType = {
  avatar: string,
  id: number,
  name: string,
  url: string
}

interface Props {
  likedUsers: Array<LikedUserType>,
  previewCount: number,
  isCurrentUserLiked: boolean
}

const LikedUsers = ({ likedUsers, previewCount, isCurrentUserLiked }: Props) => {
  let phrase = ''
  if (isCurrentUserLiked && likedUsers.length === 1) {
    phrase = 'post.like.number.only_self'
  } else if (isCurrentUserLiked && likedUsers.length > 1) {
    phrase = 'post.like.number.including_self'
  } else {
    phrase = 'post.like.number'
  }
  return (
    <div className='topic-liked-users m-v'>
      {
        likedUsers.slice(0, previewCount).map(user => (
          <UserAvatar
            user={user}
            extraClass='avatar avatar--XS'
            disablePopup
            showRank={false}
          />
        ))
      }
      <span className='topic-liked-users_text'>
        <Tooltip
          withArrow
          trigger={(
            <Phrase p={phrase}
              count={{ numberOfLikes: isCurrentUserLiked ? (likedUsers.length - 1).toString() : likedUsers.length.toString() }} />
          )}
          tooltipMessage={(
            <ul className='post-like-list__complete-list'>
              {
                likedUsers.map(likedUser => (
                  <li className='post-like-list__item'>
                    <a className='link' href={likedUser.url}>
                      <UserAvatar
                        user={likedUser}
                        extraClass='avatar avatar--S'
                        disablePopup
                        showRank={false}
                      />
                      <span>{likedUser.name}</span>
                    </a>
                  </li>
                ))
              }
            </ul>
          )}
        />
      </span>
    </div>
  )
}

export default LikedUsers
